import { useCallback } from "react";

import { Outlet, createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { Route as DocumentsRoute } from "@app/navigation/routes/_private/documents";
import { Route as PhoneVerifyRoute } from "@app/navigation/routes/_private/phone-verify";
import { Route as ProfileDetailsRoute } from "@app/navigation/routes/_private/profile-details";
import { Route as RequisitesRoute } from "@app/navigation/routes/_private/requisites";
import { Route as SecurityRoute } from "@app/navigation/routes/_private/security";
import { Route as SignInRoute } from "@app/navigation/routes/_public/sign-in";
import { ProfilePageConnector } from "@pages/profile/profile-page-connector";

export const Route = createFileRoute("/_private/profile")({
  component: RouteComponent,
  validateSearch: zodValidator(
    z.object({
      tab: z.enum(["verify"]).optional(),
    }),
  ),
});

function RouteComponent() {
  const navigate = useNavigate();
  const { tab } = Route.useSearch();
  const handleSignOut = useCallback(async () => {
    await navigate({
      to: SignInRoute.fullPath,
    });
  }, [navigate]);

  const handleSecurity = useCallback(async () => {
    await navigate({
      to: SecurityRoute.fullPath,
    });
  }, [navigate]);

  const handleRequisites = useCallback(async () => {
    await navigate({
      to: RequisitesRoute.fullPath,
    });
  }, [navigate]);

  const handleProfileDetails = useCallback(async () => {
    await navigate({
      to: ProfileDetailsRoute.fullPath,
    });
  }, [navigate]);

  const handleDocuments = useCallback(async () => {
    await navigate({
      to: DocumentsRoute.fullPath,
    });
  }, [navigate]);

  const handlePhoneVerification = useCallback(async () => {
    await navigate({
      to: PhoneVerifyRoute.fullPath,
    });
  }, [navigate]);

  return (
    <>
      <ProfilePageConnector
        tab={tab}
        onGoDocuments={handleDocuments}
        onGoPhoneVerification={handlePhoneVerification}
        onGoProfileDetails={handleProfileDetails}
        onGoRequisites={handleRequisites}
        onGoSecurity={handleSecurity}
        onSignOut={handleSignOut}
      />
      <Outlet />
    </>
  );
}
